import React, { useEffect } from 'react';
import {
    TextField,
    Box,
    Grid,
    Typography,
    Divider,
    // Paper,
} from '@mui/material';
import Chip from '@mui/material/Chip';
import ButtonContainer from '../buttoncontainer/buttonContainer';
import { makeStyles } from '@mui/styles';
import { useState, Downgraded, createState } from '@hookstate/core';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import SettingCustomDialog from '../dialog/settingDialog';

import ConfirmationDialog from '../confirmationdialog/confirmationDialog';
import SettingConfirmationDialog from '../confirmationdialog/settingConfirmationDialog';
import AllotmentItem from './allotmentItem';
import AppConstants from '../../constants/appConstants';
import CredentialAllotmentItem from './credentialAllotmentItem';

const useStyles = makeStyles({
    dialogContentRoot: {

        '&::-webkit-scrollbar': {
            width: '5px',
            height: '5px',
            backgroundColor: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
        },
    },
    boxContent: {
        display: 'flex',
        gap: 20,
        alignItems: 'center'
    },
    typographyText: {
        textAlign: 'left',
        width: '15%'
    }
});

const hotelSettingState = createState({
    hotelComp: 0,
    hotelPay: 0,
    ticketFriCompCount: 0,
    ticketSatCompCount: 0,
    ticketSunCompCount: 0,
    ticketFriPurCount: 0,
    ticketSatPurCount: 0,
    ticketSunPurCount: 0,
    ticketFriAddPurCount: 0,
    ticketSatAddPurCount: 0,
    ticketSunAddPurCount: 0,
    arrival: 0,
    departure: 0,
    business: 0,
    economy: 0,
    draftTransportCount: 0,
    draftTicketCount: 0,
    credential: 0,
    lunchRoom: 0,
    greenRoom: 0,
    draftFlight: 0
});
const TicketSettingsDialog = (props) => {
    const classes = useStyles();
    const eventInfo = useState(null);
    const userInfo = useState(null);
    const state = useState(hotelSettingState);
    const [disableButton, setDisableButton] = React.useState(false)
    const [userName, setUsername] = React.useState([])
    const [credValues, setCredValues] = React.useState()
    const [moduleRelationData, setModuleRelationData] = React.useState([])

    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
        deleteID: ''
    });
    const viewParticipantDialog = useState({
        open: false,
        title: '',
        message: [],
        tags: ''
    });


    useEffect(() => {
        if (props.isTicketOrHotel === 0) {
            state.set({
                hotelComp: 0,
                hotelPay: 0,
                ticketFriCompCount: 0,
                ticketSatCompCount: 0,
                ticketSunCompCount: 0,
                ticketFriPurCount: 0,
                ticketSatPurCount: 0,
                ticketSunPurCount: 0,
                ticketFriAddPurCount: 0,
                ticketSatAddPurCount: 0,
                ticketSunAddPurCount: 0,
                arrival: 0,
                departure: 0,
                credential: 0,
                lunchRoom: 0,
                greenRoom: 0,
                draftFlight: 0
            })
        }

        const userEventInfo = Helper.getStorage('eventInfo');
        const guserInfo = Helper.getStorage('userInfo');
        eventInfo.set(userEventInfo);
        userInfo.set(guserInfo);
        setEditData();
        handleUsername();
        getCredentialData()
    }, []);
    const setEditData = () => {
        if (props.editData !== undefined || props.editData !== '') {
            props?.editData?.actualData?.allotments.map((vals) => {
                const hotelParseData = JSON.parse(vals.hotelSetting);
                const ticketParseData = JSON.parse(vals.ticketSetting);
                const flightParseData = JSON.parse(vals.transportSetting);
                const draftTicketParseData = JSON.parse(vals.draftTicketSetting);
                const draftFlightParseData = JSON.parse(vals.draftTransportSetting);
                const credentialData = JSON.parse(vals.credentialSetting);
                setCredValues(JSON.parse(vals.credentialSetting).credential)
                const lunchRoomData = vals.lunchRoomSetting && JSON.parse(vals.lunchRoomSetting);
                const greenRoomData = vals.greenRoomSetting && JSON.parse(vals.greenRoomSetting);
                const draftFlightData = vals.draftFlightSetting && JSON.parse(vals.draftFlightSetting);
                if (props.isTicketOrHotel !== 0) {
                    if (hotelParseData !== null || ticketParseData !== null || flightParseData !== null || draftFlightParseData !== null || draftTicketParseData !== null || credentialData !== null || lunchRoomData !== null || greenRoomData !== null || draftFlightData != null) {
                        state.set({
                            hotelComp: hotelParseData?.comp,
                            hotelPay: hotelParseData?.pay,
                            ticketFriCompCount: ticketParseData?.ticketFriCompCount,
                            ticketSatCompCount: ticketParseData?.ticketSatCompCount,
                            ticketSunCompCount: ticketParseData?.ticketSunCompCount,
                            ticketFriPurCount: ticketParseData?.ticketFriPurCount,
                            ticketSatPurCount: ticketParseData?.ticketSatPurCount,
                            ticketSunPurCount: ticketParseData?.ticketSunPurCount,
                            ticketFriAddPurCount: ticketParseData?.ticketFriAddPurCount,
                            ticketSatAddPurCount: ticketParseData?.ticketSatAddPurCount,
                            ticketSunAddPurCount: ticketParseData?.ticketSunAddPurCount,
                            arrival: flightParseData?.arrival ? flightParseData?.arrival : 0,
                            departure: flightParseData?.departure ? flightParseData?.departure : 0,
                            // business: draftFlightParseData?.business ? draftFlightParseData?.business : 0,
                            // economy: draftFlightParseData?.economy ? draftFlightParseData?.economy : 0,
                            draftTransportCount: draftFlightParseData?.draftTransportCount ? draftFlightParseData?.draftTransportCount : 0,
                            draftTicketCount: draftTicketParseData?.draftTicketCount ? draftTicketParseData?.draftTicketCount : 0,
                            credential: credentialData?.credential ? !Array.isArray(credentialData?.credential) ? credentialData?.credential : 0 : 0,
                            lunchRoom: lunchRoomData?.lunchRoom ? lunchRoomData?.lunchRoom : 0,
                            greenRoom: greenRoomData?.greenRoom ? greenRoomData?.greenRoom : 0,
                            draftFlight: draftFlightData?.draftFlight ? draftFlightData?.draftFlight : 0,
                        })
                    } else {
                        state.set({
                            hotelComp: 0,
                            hotelPay: 0,
                            ticketFriCompCount: 0,
                            ticketSatCompCount: 0,
                            ticketSunCompCount: 0,
                            ticketFriPurCount: 0,
                            ticketSatPurCount: 0,
                            ticketSunPurCount: 0,
                            ticketFriAddPurCount: 0,
                            ticketSatAddPurCount: 0,
                            ticketSunAddPurCount: 0,
                            arrival: 0,
                            departure: 0,
                            business: 0,
                            economy: 0,
                            draftTicketCount: 0,
                            credential: 0,
                            lunchRoom: 0,
                            greenRoom: 0,
                            draftFlight: 0
                        })
                    }
                }
            })
        }
    }

    const handleUsername = () => {
        if (props.selectedUserIds) {
            let username = []
            let users = props.selectedUserIds;
            users.forEach((item) => {
                username.push(item.actualData.name.replace(',', ''));
                setUsername(username.join(', '));
            });
        }
    }
    const getCredentialData = () => {
        const moduleID = AppConstants.EVENT_MODULES.CREDENTIAL;
        ApiHelper.get(APIURLConstants.GET_MODULE_REMARKS(eventInfo.get().eventID, moduleID))
            .then((res) => {
                console.log(res.data);
                if (res.data && res.data.length > 0) {
                    const parseData = JSON.parse(res.data[0].relationshipRemarks)
                    // console.log("parseData", parseData, credValues);
                    setModuleRelationData(parseData)
                        if (parseData && parseData.type === 'dropdown' && parseData.options.length > 0) {
                            if (props.editData !== undefined || props.editData !== '') {
                                if(props?.editData?.actualData?.allotments?.length > 0){
                                    props?.editData?.actualData?.allotments.map((vals) => { 
                                        const credentialData = JSON.parse(vals.credentialSetting); 
                                        if (!Array.isArray(credentialData.credential)) {
                                            var objs = [] 
                                                parseData && parseData.options.map((val) => {
                                                    objs.push({
                                                        name: val.value,
                                                        value: 0
                                                    })
                                                })   
                                            setCredValues(objs)
                                        }
                                    })
                                }else{
                                    var objs = [] 
                                    parseData && parseData.options.map((val) => {
                                        objs.push({
                                            name: val.value,
                                            value: 0
                                        })
                                    })   
                                    setCredValues(objs)
                                }
                                
                            }
                        }       
                } else {
                    setModuleRelationData([])
                }
            }).catch((err) => {
                console.log(err);
            })
    }

    const onAllotmentChange = (fieldName, val) => {
         let value = Math.max(0, parseInt(val)).toString().slice(0, 7)
        state.set({
            ...state.get(),
            [fieldName]: isNaN(value) ? 0 : value,
        });
    }
    const onCredChange = (index, event) => {  
        const { value } = event.target; 
        const credvalue = Math.max(0, parseInt(value)).toString().slice(0, 7) 
        setCredValues(prev =>
            prev.map((field, i) => 
                i === index ? { ...field, value: credvalue } : field
            )
        ); 
    } 
     
    const renderDialogContent = () => (
        <>
            {userName ? (
                <Box>
                    <Typography
                        variant="h2"
                        flexGrow={1}
                        fontSize={20}
                        fontWeight={700}
                        fontFamily={'Lato'}
                        noWrap
                        fontStyle="normal"
                        color='primary'
                        component="div"
                        sx={{
                            ml: 0,
                            mb: 3,
                            textOverflow: 'unset',
                            overflow: 'unset',
                            whiteSpace: 'normal'
                        }}
                    >
                        User :
                        {props.selectedUserIds && props.selectedUserIds.map((key, i) => {
                            return <Chip key={i} sx={{ mr: '4px', mb: '2px', fontSize: '10px', height: '25px' }} label={key.actualData.name} />;
                        })
                        }
                    </Typography>
                </Box>) : null}
            <Divider orientation="horizontal" />

            <Grid
                container
                alignItems="center"
                justify="center"
                sx={{ paddingTop: 2 }}
            >
                {eventInfo && eventInfo.moduleDetails && eventInfo.moduleDetails.length > 0 ? eventInfo.moduleDetails.map((module) => {
                    const moduleData = module.attach(Downgraded).get();
                    return (<>
                        {(moduleData.moduleID === AppConstants.EVENT_MODULES.ALL_STAR_TICKET) &&
                            (<Grid item align="center" xs={12} sx={{ pl: 2, pr: 2 }}>
                                <Box className={classes.boxContent}>
                                    <Typography className={classes.typographyText} variant='subtitle2'>{moduleData.displayName} </Typography>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                                        <Typography align='left' variant='subtitle2'> Complimentary: </Typography>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '5px',
                                                width: '350px',

                                            }}
                                        >
                                            <TextField
                                                label="Fri"
                                                size="small"
                                                id="outlined-required"
                                                type="number"
                                                min={0}
                                                value={state.ticketFriCompCount.get()}
                                                onChange={(e) => {
                                                    onAllotmentChange('ticketFriCompCount', e.target.value)
                                                }}
                                            />
                                            <TextField
                                                label="sat"
                                                size="small"
                                                id="outlined-required"
                                                type="number"
                                                value={state.ticketSatCompCount.get()}
                                                onChange={(e) => {
                                                    onAllotmentChange('ticketSatCompCount', e.target.value)
                                                }}
                                            />
                                            <TextField
                                                label="Sun"
                                                size="small"
                                                id="outlined-required"
                                                type="number"
                                                value={state.ticketSunCompCount.get()}
                                                onChange={(e) => {
                                                    onAllotmentChange('ticketSunCompCount', e.target.value)
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                                        <Typography variant='subtitle2' align='left'> Purchase: </Typography>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '5px',
                                                width: '350px',
                                            }}
                                        >
                                            <TextField
                                                label="Fri"
                                                size="small"
                                                id="outlined-required"
                                                type="number"
                                                value={state.ticketFriPurCount.get()}
                                                onChange={(e) => {
                                                    onAllotmentChange('ticketFriPurCount', e.target.value)
                                                }}
                                            />
                                            <TextField
                                                label="Sat"
                                                size="small"
                                                id="outlined-required"
                                                type="number"
                                                value={state.ticketSatPurCount.get()}
                                                onChange={(e) => {
                                                    onAllotmentChange('ticketSatPurCount', e.target.value)
                                                }}
                                            />
                                            <TextField
                                                label="Sun"
                                                size="small"
                                                id="outlined-required"
                                                type="number"
                                                value={state.ticketSunPurCount.get()}
                                                onChange={(e) => {
                                                    onAllotmentChange('ticketSunPurCount', e.target.value)
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                                        <Typography align='left' variant='subtitle2'> Additional Purchase: </Typography>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '5px',
                                                width: '350px',
                                            }}
                                        >
                                            <TextField
                                                label="Fri"
                                                size="small"
                                                id="outlined-required"
                                                type="number"
                                                value={state.ticketFriAddPurCount.get()}
                                                onChange={(e) => {
                                                    onAllotmentChange('ticketFriAddPurCount', e.target.value)
                                                }}
                                            />
                                            <TextField
                                                label="Sat"
                                                size="small"
                                                id="outlined-required"
                                                type="number"
                                                value={state.ticketSatAddPurCount.get()}
                                                onChange={(e) => {
                                                    onAllotmentChange('ticketSatAddPurCount', e.target.value)
                                                }}
                                            />
                                            <TextField
                                                label="Sun"
                                                size="small"
                                                id="outlined-required"
                                                type="number"
                                                value={state.ticketSunAddPurCount.get()}
                                                onChange={(e) => {
                                                    onAllotmentChange('ticketSunAddPurCount', e.target.value)
                                                }}
                                            />

                                        </Box>
                                    </Box>
                                </Box>
                                <Divider sx={{ my: 2 }} orientation="horizontal" />
                            </Grid>)}
                        {/* {(moduleData.moduleID === AppConstants.EVENT_MODULES.CREDENTIAL) &&
                            <AllotmentItem
                                displayName={moduleData.displayName}
                                value={state.credential.get()}
                                onChange={(e) => {
                                    onAllotmentChange('credential', e.target.value)
                                }}
                            />
                        } */}
                        {(moduleData.moduleID === AppConstants.EVENT_MODULES.CREDENTIAL) &&
                            moduleRelationData && (moduleRelationData != null) ? <CredentialAllotmentItem
                            displayName={moduleData.displayName}
                            moduleRelationData={moduleRelationData}
                            dropdownValues={credValues} 
                            onCredChange={onCredChange}
                            value={state.credential.get()}
                            onChange={(e) => {
                                onAllotmentChange('credential', e.target.value)
                            }}
                        />
                            :
                            null
                        }
                        {(moduleData.moduleID === AppConstants.EVENT_MODULES.DRAFT_TICKET) &&
                            <AllotmentItem
                                displayName={moduleData.displayName}
                                value={state.draftTicketCount.get()}
                                onChange={(e) => {
                                    onAllotmentChange('draftTicketCount', e.target.value)
                                }}
                            />
                        }
                        {(moduleData.moduleID === AppConstants.EVENT_MODULES.TRANSPORTATION || moduleData.moduleID === AppConstants.EVENT_MODULES.COMBINE_FLIGHTINFO) &&
                            (<Grid item align="center" xs={12} sx={{ pl: 2, pr: 2 }}>
                                <Box className={classes.boxContent}>
                                    <Typography className={classes.typographyText} variant='subtitle2'> {moduleData.displayName} </Typography>
                                    <Box sx={{ width: '100px' }}>
                                        <TextField
                                            fullWidth
                                            sx={{
                                                marginRight: 2,
                                            }}
                                            size="small"
                                            id="outlined-required"
                                            label="Arrival"
                                            type="number"
                                            value={state.arrival.get() ? state.arrival.get() : 0}
                                            onChange={(e) => {
                                                onAllotmentChange('arrival', e.target.value)
                                            }}
                                        />
                                    </Box>
                                    <Box sx={{ width: '100px' }}>
                                        <TextField
                                            fullWidth
                                            sx={{
                                                marginRight: 2,
                                            }}
                                            size="small"
                                            id="outlined-required"
                                            label="Departure"
                                            type="number"
                                            value={state.departure.get() ? state.departure.get() : 0}
                                            onChange={(e) => {
                                                onAllotmentChange('departure', e.target.value)
                                            }}
                                        />
                                    </Box>
                                </Box>
                                <Divider sx={{ my: 2 }} orientation="horizontal" />
                            </Grid>)}
                        {(moduleData.moduleID === AppConstants.EVENT_MODULES.DRAFT_TRANSPORTATION) && (<Grid item align="center" xs={12} sx={{ pl: 2, pr: 2 }}>
                            <Box className={classes.boxContent}>
                                <Typography className={classes.typographyText} variant='subtitle2'> {moduleData.displayName} </Typography>
                                <Box sx={{ width: '100px' }}>
                                    <TextField
                                        fullWidth
                                        sx={{
                                            marginRight: 2,
                                        }}
                                        size="small"
                                        id="outlined-required"
                                        label="Draft Transport"
                                        type="number"
                                        value={state.draftTransportCount.get() ? state.draftTransportCount.get() : 0}
                                        onChange={(e) => {
                                            onAllotmentChange('draftTransportCount', e.target.value)
                                        }}
                                    />
                                </Box>
                                {/* <Box sx={{ width: '100px' }}>
                                    <TextField
                                        fullWidth
                                        sx={{
                                            marginRight: 2,
                                        }}
                                        size="small"
                                        id="outlined-required"
                                        label="Business"
                                        type="number"
                                        value={state.business.get() ? state.business.get() : 0}
                                        onChange={(e) => {
                                            onAllotmentChange('business', e.target.value)
                                        }}
                                    />
                                </Box>
                                <Box sx={{ width: '100px' }}>
                                    <TextField
                                        fullWidth
                                        sx={{
                                            marginRight: 2,
                                        }}
                                        size="small"
                                        id="outlined-required"
                                        label="Economy"
                                        type="number"
                                        value={state.economy.get() ? state.economy.get() : 0}
                                        onChange={(e) => {
                                            onAllotmentChange('economy', e.target.value)
                                        }}
                                    />
                                </Box> */}
                            </Box>
                            <Divider sx={{ my: 2 }} orientation="horizontal" />
                        </Grid>)}
                        {(moduleData.moduleID === AppConstants.EVENT_MODULES.DRAFT_HOTEL ||
                            moduleData.moduleID === AppConstants.EVENT_MODULES.COMBINE_HOTEL ||
                            moduleData.moduleID === AppConstants.EVENT_MODULES.ALL_STAR_HOTEL) &&
                            (<Grid item align="center" xs={12} sx={{ pl: 2, pr: 2 }}>
                                <Box className={classes.boxContent}>
                                    <Typography className={classes.typographyText} variant='subtitle2'> {moduleData.displayName} </Typography>
                                    <Box sx={{ width: '100px' }}>
                                        <TextField
                                            fullWidth
                                            sx={{
                                                marginRight: 2,
                                            }}
                                            size="small"
                                            id="outlined-required"
                                            label="Comp"
                                            type="number"
                                            value={state.hotelComp.get()}
                                            onChange={(e) => {
                                                onAllotmentChange('hotelComp', e.target.value)
                                            }}
                                        />
                                    </Box>
                                    <Box sx={{ width: '100px' }}>
                                        <TextField
                                            fullWidth
                                            sx={{
                                                marginRight: 2,
                                            }}
                                            size="small"
                                            id="outlined-required"
                                            label="Paid"
                                            type="number"
                                            value={state.hotelPay.get()}
                                            onChange={(e) => {
                                                onAllotmentChange('hotelPay', e.target.value)
                                            }}
                                        />
                                    </Box>
                                </Box>
                                <Divider sx={{ my: 2 }} orientation="horizontal" />
                            </Grid>)}
                        {
                            (moduleData.moduleID === AppConstants.EVENT_MODULES.DRAFT_FLIGHT_INFO) &&
                            <AllotmentItem
                                displayName={moduleData.displayName}
                                value={state.draftFlight.get()}
                                onChange={(e) => {
                                    onAllotmentChange('draftFlight', e.target.value)
                                }}
                            />
                        }
                        {(moduleData.moduleID === AppConstants.EVENT_MODULES.LUNCHROOM) &&
                            <AllotmentItem
                                displayName={moduleData.displayName}
                                value={state.lunchRoom.get()}
                                onChange={(e) => {
                                    onAllotmentChange('lunchRoom', e.target.value)
                                }}
                            />
                        }
                        {(moduleData.moduleID === AppConstants.EVENT_MODULES.GREENROOM) &&
                            <AllotmentItem
                                displayName={moduleData.displayName}
                                value={state.greenRoom.get()}
                                onChange={(e) => {
                                    onAllotmentChange('greenRoom', e.target.value)
                                }}
                            />
                        }

                    </>)
                }) : null}
            </Grid>

            {
                <SettingConfirmationDialog
                    open={viewParticipantDialog.get().open}
                    message={viewParticipantDialog.attach(Downgraded).get().tags}
                    OkButtonText={viewParticipantDialog.get().OkButtonText}
                    handleCnfClick={() => { return true; }
                    }
                    onCancelClick={() => {
                        viewParticipantDialog.set({
                            ...viewParticipantDialog.get(),
                            open: false,
                        });
                    }}></SettingConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
        </>

    )
    const handleClick = () => {
        setDisableButton(true);
        let userIDs = [];
        if (props.isTicketOrHotel === 0) {
            let users = props.selectedUserIds;
            users.forEach((item) => {
                userIDs.push(item.actualData.userID);

            });
        }

        const hotelData = {
            comp: state.get().hotelComp,
            pay: state.get().hotelPay,
        }
        const ticketData = {
            ticketFriCompCount: state.get().ticketFriCompCount,
            ticketSatCompCount: state.get().ticketSatCompCount,
            ticketSunCompCount: state.get().ticketSunCompCount,
            ticketFriPurCount: state.get().ticketFriPurCount,
            ticketSatPurCount: state.get().ticketSatPurCount,
            ticketSunPurCount: state.get().ticketSunPurCount,
            ticketFriAddPurCount: state.get().ticketFriAddPurCount,
            ticketSatAddPurCount: state.get().ticketSatAddPurCount,
            ticketSunAddPurCount: state.get().ticketSunAddPurCount,
        }
        const draftTicketSetting = {
            draftTicketCount: state.get().draftTicketCount ? state.get().draftTicketCount : 0,
        }
        const flightData = {
            arrival: state.get().arrival ? state.get().arrival : 0,
            departure: state.get().departure ? state.get().departure : 0
        }
        // const draftTransportSetting = {
        //     business: state.get().business ? state.get().business : 0,
        //     economy: state.get().economy ? state.get().economy : 0
        // }
        const draftTransportSetting = {
            draftTransportCount: state.get().draftTransportCount ? state.get().draftTransportCount : 0
        }
        let credentialSetting
        if(moduleRelationData && moduleRelationData.type === "dropdown"){
            credentialSetting = {
                credential: credValues ? credValues : 0
            }
        }else{
            credentialSetting = {
                credential: state.get().credential ? state.get().credential : 0
            }
        }
        
        const lunchRoomSetting = {
            lunchRoom: state.get().lunchRoom ? state.get().lunchRoom : 0
        }
        const greenRoomSetting = {
            greenRoom: state.get().greenRoom ? state.get().greenRoom : 0
        }
        const draftFlightSetting = {
            draftFlight: state.get().draftFlight ? state.get().draftFlight : 0
        }
        const postSettingData = {
            hotelTicketSettingID: props.isTicketOrHotel !== 0 ? props.editData.actualData.userID : 0,
            eventID: eventInfo.get().eventID,
            level: 'P',
            iDs: props.isTicketOrHotel !== 0 ? props.editData.actualData.userID.toString() : userIDs.toString(),
            type: state.get().allotment,
            hotelSetting: JSON.stringify(hotelData),
            ticketSetting: JSON.stringify(ticketData),
            transportSetting: JSON.stringify(flightData),
            modifiedBy: userInfo.get().userID,
            draftTicketSetting: JSON.stringify(draftTicketSetting),
            draftTransportSetting: JSON.stringify(draftTransportSetting),
            credentialSetting: JSON.stringify(credentialSetting),
            lunchRoomSetting: JSON.stringify(lunchRoomSetting),
            greenRoomSetting: JSON.stringify(greenRoomSetting),
            draftFlightSetting: JSON.stringify(draftFlightSetting)
        }

        ApiHelper.post(APIURLConstants.POST_HOTEL_TICKET_SETTING, postSettingData)
            .then((res) => {
                if (res.data) {
                    setDisableButton(false)
                    props.handleClose();
                    props.getParticipants()
                    state.set({
                        hotelComp: 0,
                        hotelPay: 0,
                        ticketFriCompCount: 0,
                        ticketSatCompCount: 0,
                        ticketSunCompCount: 0,
                        ticketFriPurCount: 0,
                        ticketSatPurCount: 0,
                        ticketSunPurCount: 0,
                        ticketFriAddPurCount: 0,
                        ticketSatAddPurCount: 0,
                        ticketSunAddPurCount: 0,
                    })
                    if (props.isTicketOrHotel !== 0) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Setting updated successfully',
                        });
                    } else {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Setting added successfully',
                        });
                    }
                    if (props.setShowSearchRec != undefined) {
                        props.setShowSearchRec(false);
                    }
                }
            })
            .catch((error) => {
                setDisableButton(false)
                console.log(error);
            });
    }


    const handleConfirmation = () => {
        const postSettingData = {
            ids: deleteConfirmation.get().deleteID.toString(),
            modifiedBy: userInfo.get().userID
        }

        ApiHelper.post(APIURLConstants.DELETE_HOTEL_SETTING, postSettingData)
            .then((res) => {
                if (res.data) {
                    state.set({
                        hotelComp: "",
                        hotelPay: ""
                    })
                    deleteConfirmation.set({
                        ...deleteConfirmation.get(),
                        open: false,
                    });
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Hotel Setting Deleted successfully',
                    });
                }
            }).catch((error) => {
                console.log(error);
            })
    };
    const handleClose = () => {
        props.handleClose()
        state.set({
            hotelComp: 0,
            hotelPay: 0,
            ticketFriCompCount: 0,
            ticketSatCompCount: 0,
            ticketSunCompCount: 0,
            ticketFriPurCount: 0,
            ticketSatPurCount: 0,
            ticketSunPurCount: 0,
            ticketFriAddPurCount: 0,
            ticketSatAddPurCount: 0,
            ticketSunAddPurCount: 0,
        })
    }
    const renderDialogActions = () => (
        <ButtonContainer
            handleClick={handleClick}
            handleCancel={handleClose}
            buttonText={props.isTicketOrHotel !== 0 ? 'Update' : 'Save'}
            disableButton={disableButton ? true : false}
        />
    );
    return (
        <SettingCustomDialog
            title={props.title}
            handleClose={handleClose}
            open={props.open}
            fullWidth={true}
            maxWidth={'l'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
            dialogContentClasses={{ root: classes.dialogContentRoot }}
        />
    );
};
export default TicketSettingsDialog;
